export const getLocalStorage = (key: string) => {
    if (!key) {
        return console.warn(`A key is required for useLocalStorage(key)`);
    }

    const localItem = window.localStorage.getItem(key);
    if (localItem) {
        return JSON.parse(localItem);
    } else {
        return null;
    }
};

export const setLocalStorage = (key: string, data: any) => {
    if (!key || !data) {
        return console.warn(`Both a key and data to store are required in setLocalStorage(key, data)`);
    }

    if (key) {
        window.localStorage.setItem(key, JSON.stringify(data));
    }
};

export const deleteLocalStorage = (key: string) => {
    if (!key) {
        return console.warn(`A key is required for deleteLocalStorage(key)`);
    }

    if (key) {
        window.localStorage.removeItem(key);
    }
};
